import styled from 'styled-components';

export const Section = styled.div`
  background: #fff;
  border-radius: 8px;
  padding: 20px;
  margin-bottom: 16px;
`;

export const SectionTitle = styled.h2`
  margin: 0 0 16px;
  font-size: 18px;
  color: #3f3f3f;
`;
